// saga.js
import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import PaymentsRepository from '../../../repositories/PaymentsRepository';
import PaymentsDataRepository from '../../../../data/repositories/PaymentsDataRepository';

export default function* execute(action: any): any {
  try {
    const { itemNumber } = action;
    yield put({ type: Types.GET_PAYMENT_VOUCHERS_REQUEST });
    const paymentsRepository: PaymentsRepository = new PaymentsDataRepository();
    const vouchersResponse = yield call(
      paymentsRepository.getPaymentVouchers,
      itemNumber
    );

    if (!vouchersResponse) throw new Error('response null');

    yield put({
      type: Types.GET_PAYMENT_VOUCHERS_SUCCESS,
      data: vouchersResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_PAYMENT_VOUCHERS_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos.'
    });
  }
}
